export function registerDashboard() {
    Alpine.data('dashboardApp', () => ({
        tab: 'svodka',
        svodkaSubTab: 'metrics',
        journalLayout: 'journey',
        briefData: null,
        briefCompleted: false,
        specialists: { artem: true, fedor: false, darya: false, anton: false },
        addFedorLoading: false,
        activeTeamChat: null,
        teamMobileView: 'list',
        teamMessages: [],
        onboardingMode: false,
        onboardingPending: [],
        onboardingTypingTimer: null,
        teamTypingPhase: 0,
        teamTypingTimer: null,
        teamTypingAgent: null,
        teamTypingStatus: '',
        teamInput: '',
        teamCommandsMenuOpen: false,
        teamLoading: false,
        teamTaskDoneLoading: false,
        saveDraftLoading: false,
        saveDraftMessage: '',
        saveDraftOk: false,
        teamComments: [],
        feedEvents: [],
        teamError: '',
        teamChatMeta: {},
        teamChatMoreOpen: false,
        teamChatSearchOpen: false,
        teamChatSearchQuery: '',
        teamVoiceRecording: false,
        /** Секция «Документы» на вкладке команды: по умолчанию свёрнута, компактнее страница */
        projectDocsExpanded: false,

        voiceRecorder: null,
        voiceChunks: [],
        showBriefBanner: false,
        knowledgeScore: 0,
        knowledgeNextSteps: [],
        knowledgeQuestions: [],
        knowledgeAnswerLoading: false,
        knowledgeBreakdown: null,
        knowledgeToast: '',
        weeklyFocusGoals: [],
        weeklyFocusWeekStart: '',
        weeklyFocusDraft: null,
        weeklyFocusModalOpen: false,
        weeklyFocusGenerateLoading: false,
        weeklyFocusSaveLoading: false,
        weeklyFocusMessage: '',
        smartTasksList: [],
        smartTasksTopLimit: 3,
        smartTasksGenerateLoading: false,
        smartTasksError: '',
        journalHistory: [],
        weeklyDoneToast: '',
        kpiEditorOpen: false,
        kpiEditorLoading: false,
        kpiEditorError: '',
        kpiForm: {
            revenue_month_1: null,
            revenue_month_2: null,
            revenue_month_3: null,
            average_check: null,
            leads_per_month: null,
            marketing_budget: null,
            conversion_visitor_lead: null,
            conversion_lead_sale: null,
            conversion_visitor_buyer: null,
        },
        marketingStage: 'discovery',
        stageLabel: 'Знакомство',
        documentsList: [],
        activeDocument: null,
        _docPollTimer: null,
        stageLoading: false,
        showUnreadToast: false,
        unreadTotal: 0,
        briefLoading: true,
        briefLoadFailed: false,
        _briefRetries: 0,
        _initCalled: false,

        stageDescriptions: {
            discovery: 'Знакомлюсь с бизнесом — заполните бриф, чтобы мы могли начать работу.',
            audit:     'Аудит запущен — документ готовится на вкладке «Документы». Создайте фокус недели для перехода к стратегии.',
            strategy:  'Разрабатываем стратегию роста на 90 дней — сгенерируйте задачи.',
            sprint:    'Работаем по плану — выполняйте задачи, я слежу за прогрессом и готовлю итоги.',
            review:    'Оцениваем результаты спринта — подведите итоги и скорректируем курс.',
        },

        get greeting() {
            const h = new Date().getHours();
            const salutation = h < 6 ? 'Доброй ночи' : h < 12 ? 'Доброе утро' : h < 18 ? 'Добрый день' : 'Добрый вечер';
            const name = this.briefData && this.briefData.first_name ? this.briefData.first_name : null;
            return name ? (salutation + ', ' + name + ' 👋') : (salutation + ' 👋');
        },

        get daysToWeekEnd() {
            const day = new Date().getDay();
            const toFriday = (5 - day + 7) % 7 || 7;
            return toFriday;
        },

        get heroTasksDone() {
            return this.smartTasksList.filter(t => t.status === 'completed' || t.state === 'done').length;
        },

        get heroTasksTotal() {
            return this.smartTasksList.length;
        },

        get heroTasksPct() {
            return this.heroTasksTotal > 0 ? Math.round(this.heroTasksDone / this.heroTasksTotal * 100) : 0;
        },

        get typingAgentInfo() {
            const map = {
                artem: { name: 'Артём',  avatar: '/assets/artem.jpg' },
                fedor: { name: 'Фёдор',  avatar: '/assets/fedor.jpg' },
                darya: { name: 'Дарья',  avatar: '/assets/darya.jpg' },
                anton: { name: 'Антон',  avatar: '/assets/anton.jpg' },
            };
            const id = this.teamTypingAgent || this.activeTeamChat;
            return map[id] || map['artem'];
        },

        get teamChatList() {
            const list = [];
            const projectName = this.briefData && this.briefData.company_name
                ? this.briefData.company_name
                : 'Проект';
            list.push({ id: 'team_general', name: projectName });
            list.push({ id: 'artem', name: 'Артем' });
            if (this.specialists.fedor) list.push({ id: 'fedor', name: 'Федор' });
            if (this.specialists.darya) list.push({ id: 'darya', name: 'Дарья' });
            if (this.specialists.anton) list.push({ id: 'anton', name: 'Антон' });
            return list;
        },

        teamCommandsByChat: {
            team_general: [
                { cmd: '@artem funnel', desc: 'Разбор воронки и шаги для роста выручки' },
                { cmd: '@artem hypotheses', desc: 'Маркетинговые гипотезы с оценкой влияния' },
                { cmd: '@artem weekly_focus', desc: 'Цели и фокус на неделю' },
                { cmd: '@artem next_actions', desc: 'Следующие шаги и smart-задачи' },
                { cmd: '@artem explain_metrics', desc: 'Объяснить метрики и KPI' },
            ],
            artem: [
                { cmd: '@artem funnel', desc: 'Разбор воронки и шаги для роста выручки' },
                { cmd: '@artem hypotheses', desc: 'Маркетинговые гипотезы с оценкой влияния' },
                { cmd: '@artem weekly_focus', desc: 'Цели и фокус на неделю' },
                { cmd: '@artem next_actions', desc: 'Следующие шаги и smart-задачи' },
                { cmd: '@artem explain_metrics', desc: 'Объяснить метрики и KPI' },
            ],
            fedor: [
                { cmd: '@fedor tasks', desc: 'Список задач по SEO-аудиту' },
                { cmd: '@fedor recheck', desc: 'Перепроверить сайт' },
                { cmd: '@fedor recommended', desc: 'Рекомендованные запросы' },
                { cmd: '@fedor positions', desc: 'Срез позиций по запросам' },
                { cmd: '@fedor done 1', desc: 'Отметить задачу выполненной (1 — номер)' },
            ],
            darya: [
                { cmd: '@darya plan', desc: 'Контент-план на неделю' },
                { cmd: '@darya post', desc: 'Черновик поста (можно добавить тему)' },
                { cmd: '@darya stats', desc: 'Статистика и идеи по постам' },
            ],
        },
        get teamChatCommandsList() {
            const chat = this.activeTeamChat || 'team_general';
            return this.teamCommandsByChat[chat] || this.teamCommandsByChat.team_general || [];
        },
        pickTeamCommand(c) {
            this.teamInput = c.cmd + (c.cmd.endsWith(' ') ? '' : ' ');
            this.teamCommandsMenuOpen = false;
            this.$nextTick(() => this.$refs.teamInput && this.$refs.teamInput.focus());
        },

        /** Подпись роли в сайдбаре чатов (вместо одинаковой «Активность» для всех) */
        teamChatRoleLabel(chatId) {
            const map = {
                team_general: 'Общий чат',
                artem: 'Маркетолог',
                fedor: 'SEO',
                darya: 'SMM',
                anton: 'Директ',
            };
            return map[chatId] || '';
        },

        formatTime(ts) {
            if (!ts) return '';
            const d = new Date(ts);
            if (Number.isNaN(d.getTime())) return '';
            return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
        },

        /** Календарный день сообщения в локальной таймзоне (для сравнения подряд идущих строк) */
        _chatDayKey(iso) {
            if (!iso) return '';
            const d = new Date(iso);
            if (Number.isNaN(d.getTime())) return '';
            return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
        },
        /** Плашка «как в Telegram»: над первым сообщением и когда день сменился относительно предыдущей строки */
        teamShowDateSeparator(idx) {
            const i = Number(idx);
            if (Number.isNaN(i)) return false;
            const list = this.teamMessages;
            if (!list || !list.length || i < 0 || i >= list.length) return false;
            if (i === 0) return true;
            const cur = this._chatDayKey(list[i].created_at);
            const prev = this._chatDayKey(list[i - 1].created_at);
            if (!cur && !prev) return false;
            return cur !== prev;
        },
        /** Текст плашки: Сегодня / Вчера / «12 марта» / с годом, если не текущий год */
        teamChatDateSeparatorLabel(idx) {
            const i = Number(idx);
            if (Number.isNaN(i)) return '';
            const list = this.teamMessages;
            const m = list && list[i];
            if (!m) return '';
            const iso = m.created_at;
            const d = iso ? new Date(iso) : new Date();
            if (Number.isNaN(d.getTime())) {
                return new Date().toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
            }
            const now = new Date();
            const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
            const msgDay = startOf(d);
            const today = startOf(now);
            const dayDiff = Math.round((today - msgDay) / 86400000);
            if (dayDiff === 0) return 'Сегодня';
            if (dayDiff === 1) return 'Вчера';
            const opts = { day: 'numeric', month: 'long' };
            if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
            return d.toLocaleDateString('ru-RU', opts);
        },

        renderMarkdown(text) {
            if (!text) return '';
            const t = String(text);
            if (typeof marked === 'undefined') return t.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            const raw = marked.parse(t, { gfm: true, breaks: true });
            if (typeof DOMPurify !== 'undefined') {
                return DOMPurify.sanitize(raw, { ALLOWED_TAGS: ['p','br','strong','b','em','i','code','pre','a','ul','ol','li','h1','h2','h3','h4','blockquote','hr','span','div'] });
            }
            return raw;
        },

        formatMoney(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (isNaN(n)) return '—';
            return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n) + ' ₽';
        },
        formatNextSmmPost(iso, theme) {
            if (!iso) return '—';
            const d = new Date(String(iso).replace(' ', 'T'));
            if (Number.isNaN(d.getTime())) return '—';
            const dateStr = d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
            const timeStr = d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
            const out = dateStr + ', ' + timeStr;
            return (theme && theme.trim()) ? out + ' — ' + theme.trim() : out;
        },
        formatPercent(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (isNaN(n)) return '—';
            return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(n) + '%';
        },
        avgRevenue(kpi) {
            if (!kpi) return null;
            const a = kpi.revenue_month_1, b = kpi.revenue_month_2, c = kpi.revenue_month_3;
            if (a == null && b == null && c == null) return null;
            const sum = (a || 0) + (b || 0) + (c || 0);
            const cnt = [a, b, c].filter(x => x != null).length;
            return cnt ? sum / cnt : null;
        },
        avgCac(cacList) {
            if (!Array.isArray(cacList) || cacList.length === 0) return null;
            const sum = cacList.reduce((s, x) => s + (x.cac ?? 0), 0);
            return sum / cacList.length;
        },
        progressToGoal(data) {
            if (!data || !data.kpi || !data.goals || data.goals.goal_revenue == null) return 0;
            const current = this.avgRevenue(data.kpi);
            if (current == null || current <= 0) return 0;
            const goal = Number(data.goals.goal_revenue);
            if (goal <= 0) return 100;
            return Math.round((current / goal) * 100);
        },

        getRevenueBars() {
            if (!this.briefData || !this.briefData.kpi) return [];
            const k = this.briefData.kpi;
            return [
                { label: '1-й месяц', value: k.revenue_month_1 != null ? k.revenue_month_1 : null },
                { label: '2-й месяц', value: k.revenue_month_2 != null ? k.revenue_month_2 : null },
                { label: '3-й месяц', value: k.revenue_month_3 != null ? k.revenue_month_3 : null },
            ];
        },
        maxRevenue() {
            const bars = this.getRevenueBars();
            if (!bars.length) return 0;
            return Math.max(0, ...bars.map(b => b.value ?? 0), 1);
        },
        formatInt(v) {
            if (v == null || v === '') return '—';
            const n = Math.round(Number(v));
            return isNaN(n) ? '—' : new Intl.NumberFormat('ru-RU').format(n);
        },
        funnelSteps(data) {
            if (!data || !data.kpi) return [];
            const k = data.kpi;
            const leads = k.leads_per_month != null ? Number(k.leads_per_month) : null;
            const convLead = k.conversion_visitor_lead != null ? Number(k.conversion_visitor_lead) : null;
            const convSale = k.conversion_lead_sale != null ? Number(k.conversion_lead_sale) : null;
            if (leads == null || leads < 0) return [];
            const visitors = (convLead != null && convLead > 0) ? Math.round(leads * 100 / convLead) : null;
            const sales = (convSale != null && convSale >= 0) ? Math.round(leads * convSale / 100) : null;
            const steps = [];
            if (visitors != null && visitors >= 0) steps.push({ key: 'visitors', label: 'Посетители', value: visitors });
            steps.push({ key: 'leads', label: 'Лиды', value: leads });
            if (sales != null && sales >= 0) steps.push({ key: 'sales', label: 'Продажи', value: sales });
            return steps.map(s => ({ ...s, text: this.formatInt(s.value) }));
        },
        funnelSummaryText() {
            if (!this.briefData || !this.briefData.kpi) return '';
            const steps = this.funnelSteps(this.briefData);
            if (!steps.length) return '';
            const find = (key) => {
                const s = steps.find(x => x.key === key);
                return s ? s.text : '—';
            };
            const k = this.briefData.kpi;
            const convLead = k.conversion_visitor_lead != null ? Number(k.conversion_visitor_lead) : null;
            const convSale = k.conversion_lead_sale != null ? Number(k.conversion_lead_sale) : null;
            const convTotal = k.conversion_visitor_buyer != null ? Number(k.conversion_visitor_buyer) : null;

            let text = 'Сейчас примерно ' + find('visitors') + ' посетителей → ' + find('leads') + ' лидов';
            const salesText = find('sales');
            if (salesText !== '—') {
                text += ' → ' + salesText + ' продаж';
            }
            text += ' в месяц.';

            const convParts = [];
            if (convLead != null) convParts.push('посетитель → лид: ' + this.formatPercent(convLead));
            if (convSale != null) convParts.push('лид → продажа: ' + this.formatPercent(convSale));
            if (convTotal != null) convParts.push('посетитель → покупатель: ' + this.formatPercent(convTotal));
            if (convParts.length) {
                text += ' Конверсии: ' + convParts.join('; ') + '.';
            }
            return text;
        },

        budgetPieColors: ['#4f46e5', '#6366f1', '#818cf8', '#a5b4fc', '#c4b5fd', '#e0e7ff'],

        _revenueChart: null,
        _channelsBudgetChart: null,
        _funnelChart: null,

        get isLocked() {
            return !this.briefCompleted;
        },

        get primaryWeeklyGoal() {
            if (!Array.isArray(this.weeklyFocusGoals) || this.weeklyFocusGoals.length === 0) return null;
            const primary = this.weeklyFocusGoals.find(g => g.is_primary);
            return primary || this.weeklyFocusGoals[0] || null;
        },

        get weeklyFocusWeekLabel() {
            if (!this.weeklyFocusWeekStart) return '';
            const start = new Date(this.weeklyFocusWeekStart);
            if (Number.isNaN(start.getTime())) return '';
            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            const startStr = start.toLocaleDateString('ru-RU');
            const endStr = end.toLocaleDateString('ru-RU');
            return 'Неделя ' + startStr + ' — ' + endStr;
        },

        get goalBlock() {
            const brief = this.briefData || {};
            const goals = brief.goals || {};
            const kpi = brief.kpi || null;
            const current = kpi ? this.avgRevenue(kpi) : null;
            return {
                current,
                target: goals.goal_revenue != null ? goals.goal_revenue : null,
                horizon: goals.goal_horizon || null,
                growthFactor: goals.goal_growth_factor != null ? goals.goal_growth_factor : null,
                progressPercent: this.progressToGoal(brief),
            };
        },

        get weeklyFocus() {
            const goal = this.primaryWeeklyGoal;
            return {
                title: goal && goal.title ? goal.title : '',
                description: goal && goal.description ? goal.description : '',
                weekLabel: this.weeklyFocusWeekLabel,
            };
        },

        get weeklyTasks() {
            if (!Array.isArray(this.smartTasksList)) return [];
            return this.smartTasksList;
        },

        get weeklyTotalCount() {
            return Array.isArray(this.weeklyTasks) ? this.weeklyTasks.length : 0;
        },

        get weeklyDoneCount() {
            if (!Array.isArray(this.weeklyTasks) || this.weeklyTasks.length === 0) return 0;
            return this.weeklyTasks.filter(t => t.state === 'done').length;
        },

        get weeklyProgressPercent() {
            const total = this.weeklyTotalCount;
            if (!total) return 0;
            const done = this.weeklyDoneCount;
            return Math.round((done / total) * 100);
        },

        missing() {
            const k = this.briefData && this.briefData.kpi ? this.briefData.kpi : {};
            return {
                ltv: k.ltv == null,
                ltvCac: k.ltv_cac_ratio == null,
                funnel: k.conversion_visitor_lead == null || k.conversion_lead_sale == null,
                revenue: k.revenue_month_1 == null && k.revenue_month_2 == null && k.revenue_month_3 == null,
            };
        },

        openKpiEditor() {
            if (!this.briefData || !this.briefData.kpi) return;
            const k = this.briefData.kpi;
            this.kpiForm = {
                revenue_month_1: k.revenue_month_1 ?? null,
                revenue_month_2: k.revenue_month_2 ?? null,
                revenue_month_3: k.revenue_month_3 ?? null,
                average_check: k.average_check ?? null,
                leads_per_month: k.leads_per_month ?? null,
                marketing_budget: k.marketing_budget ?? null,
                conversion_visitor_lead: k.conversion_visitor_lead ?? null,
                conversion_lead_sale: k.conversion_lead_sale ?? null,
                conversion_visitor_buyer: k.conversion_visitor_buyer ?? null,
            };
            this.kpiEditorError = '';
            this.kpiEditorOpen = true;
        },
        closeKpiEditor() {
            if (this.kpiEditorLoading) return;
            this.kpiEditorOpen = false;
            this.kpiEditorError = '';
        },
        async saveKpiEditor() {
            if (!this.briefData) return;
            this.kpiEditorLoading = true;
            this.kpiEditorError = '';
            try {
                const payload = { ...this.kpiForm };
                const r = await fetch('/api/brief/patch', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() },
                    body: JSON.stringify(payload),
                });
                const d = await r.json().catch(() => ({}));
                if (!r.ok || d.error) {
                    this.kpiEditorError = d.error || 'Не удалось сохранить изменения.';
                } else {
                    if (d.brief) {
                        this.briefData = d.brief;
                        this.initCharts();
                    } else {
                        await this.loadBrief();
                    }
                    this.kpiEditorOpen = false;
                }
            } catch (_) {
                this.kpiEditorError = 'Ошибка сети при сохранении.';
            }
            this.kpiEditorLoading = false;
        },

        getChannelsTable() {
            const actual = this.briefData && Array.isArray(this.briefData.channels_actual) && this.briefData.channels_actual.length > 0
                ? this.briefData.channels_actual
                : null;
            if (actual) return actual;
            if (!this.briefData || !this.briefData.channels) return [];
            const budget = this.briefData.channels.budget || [];
            const cac = this.briefData.channels.cac || [];
            const byChannel = {};
            budget.forEach(b => { byChannel[b.channel] = { ...(byChannel[b.channel] || {}), channel: b.channel, budget: b.budget }; });
            cac.forEach(c => { byChannel[c.channel] = { ...(byChannel[c.channel] || {}), channel: c.channel, cac: c.cac }; });
            return Object.values(byChannel).filter(r => r.channel).sort((a, b) => (b.budget ?? 0) - (a.budget ?? 0));
        },

        getBudgetPieSegments() {
            const actual = this.briefData && Array.isArray(this.briefData.channels_actual) && this.briefData.channels_actual.length > 0
                ? this.briefData.channels_actual
                : null;
            if (actual) {
                const budget = actual.filter(b => b.budget != null && Number(b.budget) > 0);
                if (!budget.length) return [];
                const total = budget.reduce((s, b) => s + Number(b.budget), 0);
                if (total <= 0) return [];
                return budget.map(b => {
                    const v = Number(b.budget);
                    const p = (v / total) * 100;
                    return { channel: b.channel || '—', budget: v, percent: p, percentText: p.toFixed(1) + '%' };
                });
            }
            if (!this.briefData || !this.briefData.channels || !this.briefData.channels.budget) return [];
            const budget = this.briefData.channels.budget.filter(b => b.budget != null && Number(b.budget) > 0);
            if (!budget.length) return [];
            const total = budget.reduce((s, b) => s + Number(b.budget), 0);
            if (total <= 0) return [];
            let cumul = 0;
            return budget.map(b => {
                const v = Number(b.budget);
                const p = (v / total) * 100;
                cumul += p;
                return { channel: b.channel || '—', budget: v, percent: p, percentText: p.toFixed(1) + '%' };
            });
        },

        getBudgetPieGradient() {
            const segs = this.getBudgetPieSegments();
            if (!segs.length) return 'transparent 0%';
            const colors = this.budgetPieColors;
            let cumul = 0;
            return segs.map((s, i) => {
                const start = cumul;
                cumul += s.percent;
                return colors[i % colors.length] + ' ' + start + '% ' + cumul + '%';
            }).join(', ');
        },

        knowledgeKnownLabels() {
            const b = this.knowledgeBreakdown;
            if (!b || !Array.isArray(b.categories)) return [];
            const out = [];
            b.categories.forEach((c) => {
                if (!c || typeof c !== 'object') return;
                const filled = c.filled ?? 0;
                const total = c.total ?? 0;
                if (total > 0 && filled / total >= 0.7) {
                    out.push(c.title);
                }
            });
            if (b.extended_answered && b.extended_total) {
                if (b.extended_answered >= 1) {
                    out.push('расширенные ответы о нюансах бизнеса');
                }
            }
            return out;
        },
        knowledgeMissingLabels() {
            const b = this.knowledgeBreakdown;
            if (!b || !Array.isArray(b.categories)) return [];
            const out = [];
            b.categories.forEach((c) => {
                if (!c || typeof c !== 'object') return;
                const filled = c.filled ?? 0;
                const total = c.total ?? 0;
                if (total > 0 && filled / total < 0.7) {
                    out.push(c.title);
                }
            });
            if (b.extended_total && (b.extended_answered ?? 0) < b.extended_total) {
                out.push('ответы на дополнительные вопросы («Вопрос дня»)');
            }
            return out;
        },

        seoSummaryText(summary) {
            if (!summary) return '';
            const phrases = Number(summary.phrases_count ?? 0);
            const budget = summary.budget_daily != null ? Number(summary.budget_daily) : null;
            const status = String(summary.status_label || '').toLowerCase();

            if (!phrases || phrases <= 0) {
                return 'SEO-канал подключён, но фразы ещё не выбраны — пока трафик из него не идёт.';
            }

            let sentence = `Сейчас в продвижении около ${phrases} фраз`;
            if (budget && budget > 0) {
                const b = Math.round(budget).toLocaleString('ru-RU');
                sentence += ` с бюджетом примерно ${b} ₽ в сутки`;
            }
            sentence += '.';

            if (status.includes('ожид') || status.includes('pending')) {
                sentence += ' По статусу канал в ожидании — дождитесь запуска и посмотрите первые изменения позиций.';
            } else if (status.includes('приост') || status.includes('paused')) {
                sentence += ' Сейчас канал приостановлен: возобновите его, если хотите вернуть регулярный SEO-трафик.';
            } else if (status.includes('ошиб') || status.includes('error')) {
                sentence += ' В канале есть ошибка — стоит открыть раздел SEO и проверить настройки проекта.';
            } else if (status.includes('запущ') || status.includes('active')) {
                sentence += ' Канал запущен: следите за динамикой позиций и трафика в этом разделе.';
            }

            return sentence;
        },

        get smartTasksTop() {
            if (!Array.isArray(this.smartTasksList) || this.smartTasksList.length === 0) return [];
            const active = this.smartTasksList.filter(t => !t.state || t.state === 'todo');
            if (active.length === 0) return [];
            const sorted = [...active].sort((a, b) => {
                const impactA = a.impact_score ?? 0;
                const impactB = b.impact_score ?? 0;
                const urgencyA = a.urgency_score ?? 0;
                const urgencyB = b.urgency_score ?? 0;
                if (impactA !== impactB) return impactB - impactA;
                return urgencyB - urgencyA;
            });
            return sorted.slice(0, this.smartTasksTopLimit);
        },

        get currentWeeklyTask() {
            const list = this.smartTasksTop;
            return Array.isArray(list) && list.length ? list[0] : null;
        },

        get otherWeeklyTasks() {
            const list = this.smartTasksTop;
            if (!Array.isArray(list) || list.length <= 1) return [];
            return list.slice(1);
        },

        formatWeekRange(weekStart) {
            if (!weekStart) return '';
            const start = new Date(weekStart);
            if (Number.isNaN(start.getTime())) return String(weekStart);
            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            const startStr = start.toLocaleDateString('ru-RU');
            const endStr = end.toLocaleDateString('ru-RU');
            return startStr + ' — ' + endStr;
        },

        taskImpactLabel(score) {
            if (score == null) return '';
            const n = Number(score);
            if (Number.isNaN(n)) return '';
            if (n >= 8) return 'Большой эффект';
            if (n >= 5) return 'Средний эффект';
            if (n > 0) return 'Небольшой эффект';
            return '';
        },

        taskEffortLabel(score) {
            if (score == null) return '';
            const n = Number(score);
            if (Number.isNaN(n)) return '';
            if (n <= 3) return 'Быстрый шаг';
            if (n <= 6) return 'Среднее усилие';
            return 'Нужно время';
        },

        taskUrgencyLabel(score) {
            if (score == null) return '';
            const n = Number(score);
            if (Number.isNaN(n)) return '';
            if (n >= 8) return 'Важно сейчас';
            if (n >= 5) return 'Желательно в ближайшее время';
            if (n > 0) return 'Можно позже';
            return '';
        },

        lastAssistantMessageIndex() {
            const list = this.teamMessages || [];
            for (let i = list.length - 1; i >= 0; i--) {
                if (list[i].role !== 'user' && list[i].role !== 'system') return i;
            }
            return -1;
        },
        getLastUserMessageBefore(idx) {
            const list = this.teamMessages || [];
            const i0 = Number(idx);
            if (Number.isNaN(i0)) return '';
            for (let i = i0 - 1; i >= 0; i--) {
                if (list[i].role === 'user') return list[i].content || '';
            }
            return '';
        },
        extractThemeFromDaryaPost(msg) {
            if (!msg || typeof msg !== 'string') return '';
            const m = msg.trim().match(/@darya\s+post\s+(.+)/si);
            return m ? m[1].trim().slice(0, 200) : '';
        },
        saveDaryaDraftToPosts(assistantContent, idx) {
            if (!assistantContent) return;
            this.saveDraftMessage = '';
            this.saveDraftOk = false;
            this.saveDraftLoading = true;
            const userMsg = this.getLastUserMessageBefore(idx);
            const theme = this.extractThemeFromDaryaPost(userMsg) || 'Из чата с Дарьей';
            fetch('/api/smm/posts/save-draft', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() },
                body: JSON.stringify({ theme, text: assistantContent })
            })
                .then(r => r.json())
                .then(data => {
                    this.saveDraftLoading = false;
                    if (data.ok) {
                        this.saveDraftOk = true;
                        this.saveDraftMessage = 'Сохранено.';
                        setTimeout(() => { this.saveDraftMessage = ''; this.saveDraftOk = false; }, 4000);
                    } else {
                        this.saveDraftMessage = data.error || 'Ошибка';
                    }
                })
                .catch(() => {
                    this.saveDraftLoading = false;
                    this.saveDraftMessage = 'Ошибка сети';
                });
        },
        senderForTeamMessage(m) {
            if (m.role === 'user') {
                return { name: 'Вы', initials: 'В', color: 'bg-slate-900 text-white', avatar: null };
            }
            if (m.role === 'system') {
                return { name: 'Система', initials: 'S', color: 'bg-slate-200 text-slate-500', avatar: null };
            }
            if (m.agent_id === 'artem' || this.activeTeamChat === 'artem') return { name: 'Артём', initials: 'А', color: 'bg-slate-200 text-slate-700', avatar: '/assets/artem.jpg' };
            if (m.agent_id === 'fedor' || this.activeTeamChat === 'fedor') return { name: 'Фёдор', initials: 'Ф', color: 'bg-amber-100 text-amber-700', avatar: '/assets/fedor.jpg' };
            if (m.agent_id === 'darya' || this.activeTeamChat === 'darya') return { name: 'Дарья', initials: 'Д', color: 'bg-violet-100 text-violet-700', avatar: '/assets/darya.jpg' };
            if (m.agent_id === 'anton' || this.activeTeamChat === 'anton') return { name: 'Антон', initials: 'Ан', color: 'bg-blue-100 text-blue-700', avatar: '/assets/anton.jpg' };
            const text = (m.content || '').toString();
            if (text.startsWith('Фёдор')) return { name: 'Фёдор', initials: 'Ф', color: 'bg-amber-100 text-amber-700', avatar: '/assets/fedor.jpg' };
            if (text.startsWith('Артём')) return { name: 'Артём', initials: 'А', color: 'bg-slate-200 text-slate-700', avatar: '/assets/artem.jpg' };
            if (text.startsWith('Дарья')) return { name: 'Дарья', initials: 'Д', color: 'bg-violet-100 text-violet-700', avatar: '/assets/darya.jpg' };
            if (text.startsWith('Антон')) return { name: 'Антон', initials: 'Ан', color: 'bg-blue-100 text-blue-700', avatar: '/assets/anton.jpg' };
            return { name: 'Команда', initials: 'К', color: 'bg-slate-200 text-slate-700', avatar: null };
        },

        init() {
            if (this._initCalled) return;
            this._initCalled = true;

            const search = window.location.search || '';
            const params = new URLSearchParams(search);
            const tabParam = params.get('tab');
            this.onboardingMode = params.get('onboarding') === '1';
            if (tabParam === 'team') {
                this.tab = 'team';
            } else if (tabParam === 'journal') {
                this.tab = 'svodka';
                this.svodkaSubTab = 'journal';
            } else {
                const hash = (window.location.hash || '#svodka').slice(1);
                this.tab = hash === 'team' ? 'team' : 'svodka';
            }

            const layoutParam = params.get('journal_layout');
            if (layoutParam === 'journey' || layoutParam === 'hud' || layoutParam === 'mixed') {
                this.journalLayout = layoutParam;
            }
            this.briefCompleted = this.$el.dataset.briefCompleted === 'true';
            this.showBriefBanner = this.$el.dataset.briefJustCompleted === 'true';
            this.marketingStage = this.$el.dataset.marketingStage || 'discovery';
            this.stageLabel = this.$el.dataset.stageLabel || 'Знакомство';
            window.addEventListener('hashchange', () => {
                const h = (window.location.hash || '#svodka').slice(1);
                this.tab = h === 'team' ? 'team' : 'svodka';
            });
            this.loadBrief();
            this.loadTeam();
            this.loadFeed();
            this._checkUnread();
            if (this.tab === 'team') {
                this.$nextTick(() => this.selectTeamChat('team_general'));
            }
        },

        async _checkUnread() {
            if (sessionStorage.getItem('unread_toast_dismissed')) return;
            try {
                const r = await fetch('/api/chat/unread-count');
                if (!r.ok) return;
                const d = await r.json();
                this.unreadTotal = d.total || 0;
                if (this.unreadTotal > 0 && this.tab !== 'team' && !this.onboardingMode) {
                    this.showUnreadToast = true;
                }
            } catch (e) {}
        },

        dismissUnreadToast() {
            this.showUnreadToast = false;
            sessionStorage.setItem('unread_toast_dismissed', '1');
        },

        goToChat() {
            this.showUnreadToast = false;
            sessionStorage.setItem('unread_toast_dismissed', '1');
            this.tab = 'team';
            this.$nextTick(() => this.selectTeamChat('team_general'));
        },

        async loadDocuments() {
            try {
                const r = await fetch('/api/documents');
                if (!r.ok) return;
                const d = await r.json();
                this.documentsList = d.documents || [];
            } catch (e) {}
        },

        async viewDocument(id) {
            try {
                const r = await fetch('/api/documents/view?id=' + id);
                if (!r.ok) return;
                this.activeDocument = await r.json();
                if (!this.activeDocument.is_complete) {
                    this.startDocPolling();
                } else {
                    this.stopDocPolling();
                }
            } catch (e) {}
        },

        async refreshDocument() {
            if (!this.activeDocument) return;
            await this.viewDocument(this.activeDocument.id);
            if (this.activeDocument && this.activeDocument.is_complete) {
                this.stopDocPolling();
            }
        },

        startDocPolling() {
            this.stopDocPolling();
            this._docPollTimer = setInterval(async () => {
                if (!this.activeDocument || this.activeDocument.is_complete) {
                    this.stopDocPolling();
                    return;
                }
                await this.refreshDocument();
            }, 4000);
        },

        stopDocPolling() {
            if (this._docPollTimer) {
                clearInterval(this._docPollTimer);
                this._docPollTimer = null;
            }
        },

        async reloadStage() {
            try {
                const r = await fetch('/api/project/stage');
                if (r.ok) {
                    const d = await r.json();
                    this.marketingStage = d.stage;
                    this.stageLabel = d.stage_label;
                }
            } catch (_) {}
        },

        formatDate(dt) {
            if (!dt) return '';
            const d = new Date(dt);
            return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
        },

        async setStageReview() {
            if (this.stageLoading) return;
            this.stageLoading = true;
            try {
                const r = await fetch('/api/project/stage', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': window.getCsrfToken(),
                    },
                    body: JSON.stringify({ stage: 'review' }),
                });
                const d = await r.json();
                if (r.ok) {
                    this.marketingStage = d.stage;
                    this.stageLabel = d.stage_label;
                } else {
                    this.teamError = d.error || 'Не удалось сменить стадию';
                }
            } catch (e) {
                this.teamError = 'Ошибка сети';
            } finally {
                this.stageLoading = false;
            }
        },
        baseChartAnimations: {
            enabled: true,
            easing: 'easeout',
            speed: 500,
            animateGradually: {
                enabled: true,
                delay: 80
            }
        },

        initCharts() {
            if (typeof ApexCharts === 'undefined') return;
            this.$nextTick(() => {
                this.updateRevenueChart();
                this.updateChannelsBudgetChart();
                this.updateFunnelChart();
            });
        },
        updateRevenueChart() {
            if (!this.briefData || !this.briefData.kpi) return;
            const bars = this.getRevenueBars();
            if (!bars.some(b => b.value != null)) return;
            const el = this.$refs.revenueChart;
            if (!el || typeof ApexCharts === 'undefined') return;

            const categories = bars.map(b => b.label);
            const data = bars.map(b => b.value ?? 0);
            const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

            const options = {
                chart: { type: 'bar', height: 260, toolbar: { show: false }, fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', animations: this.baseChartAnimations },
                series: [{ name: 'Выручка', data: data }],
                xaxis: { categories: categories, labels: { style: { colors: '#6b7280', fontSize: isMobile ? '10px' : '12px' } }, axisBorder: { show: false }, axisTicks: { show: false } },
                yaxis: { labels: { formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n / 1000) + 'k ₽'; }, style: { colors: '#9ca3af', fontSize: isMobile ? '10px' : '11px' } } },
                plotOptions: { bar: { borderRadius: 6, columnWidth: isMobile ? '55%' : '40%', dataLabels: { position: isMobile ? 'top' : 'center' } } },
                dataLabels: { enabled: true, formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n); }, style: { colors: ['#111827'], fontSize: isMobile ? '9px' : '11px', fontWeight: 500 } },
                tooltip: { y: { formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n) + ' ₽'; } } },
                colors: ['#4f46e5'],
                grid: { borderColor: '#e5e7eb', strokeDashArray: 4 }
            };

            if (!this._revenueChart) {
                this._revenueChart = new ApexCharts(el, options);
                this._revenueChart.render();
            } else {
                this._revenueChart.updateOptions(options, false, true);
            }
        },
        updateChannelsBudgetChart() {
            if (!this.briefData) return;
            const segs = this.getBudgetPieSegments();
            if (!segs.length) return;

            const el = this.$refs.channelsBudgetChart;
            if (!el || typeof ApexCharts === 'undefined') return;

            const series = segs.map(s => s.budget);
            const labels = segs.map(s => s.channel);

            const options = {
                chart: { type: 'donut', height: 260, toolbar: { show: false }, fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', animations: this.baseChartAnimations },
                plotOptions: { pie: { expandOnClick: false } },
                series: series,
                labels: labels,
                colors: this.budgetPieColors,
                legend: { position: 'right', labels: { colors: '#4b5563' }, fontSize: '12px' },
                dataLabels: { enabled: true, formatter: (val) => `${val.toFixed(1)}%`, style: { fontSize: '11px', fontWeight: 500 } },
                tooltip: { y: { formatter: (val, { seriesIndex }) => { const n = Number(val); if (!Number.isFinite(n)) return ''; const pct = (segs[seriesIndex] && Number.isFinite(segs[seriesIndex].percent)) ? segs[seriesIndex].percent.toFixed(1) + '%' : ''; const money = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n) + ' ₽'; return pct ? `${money} · ${pct}` : money; } } },
                stroke: { colors: ['#ffffff'], width: 1 }
            };

            if (!this._channelsBudgetChart) {
                this._channelsBudgetChart = new ApexCharts(el, options);
                this._channelsBudgetChart.render();
            } else {
                this._channelsBudgetChart.updateOptions(options, false, true);
            }
        },
        updateFunnelChart() {
            if (!this.briefData || !this.briefData.kpi) return;
            const steps = this.funnelSteps(this.briefData);
            if (!steps.length) return;

            const el = this.$refs.funnelChart;
            if (!el || typeof ApexCharts === 'undefined') return;

            const categories = steps.map(s => s.label);
            const data = steps.map(s => s.value ?? 0);
            const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

            const options = {
                chart: { type: 'bar', height: 260, toolbar: { show: false }, fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', animations: this.baseChartAnimations, padding: isMobile ? { bottom: 24 } : undefined },
                series: [{ name: 'Количество', data: data }],
                xaxis: { categories: categories, labels: { style: { colors: '#6b7280', fontSize: isMobile ? '10px' : '12px' }, maxHeight: isMobile ? 50 : undefined }, axisBorder: { show: false }, axisTicks: { show: false } },
                yaxis: { labels: { formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n); }, style: { colors: '#9ca3af', fontSize: isMobile ? '10px' : '11px' } } },
                plotOptions: { bar: { borderRadius: 6, columnWidth: isMobile ? '55%' : '45%' } },
                dataLabels: { enabled: true, formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n); }, style: { colors: ['#111827'], fontSize: isMobile ? '9px' : '11px', fontWeight: 500 } },
                tooltip: { y: { formatter: (val) => { const n = Number(val); if (!Number.isFinite(n)) return ''; return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n); } } },
                colors: ['#6366f1'],
                grid: { borderColor: '#e5e7eb', strokeDashArray: 4 }
            };

            if (!this._funnelChart) {
                this._funnelChart = new ApexCharts(el, options);
                this._funnelChart.render();
            } else {
                this._funnelChart.updateOptions(options, false, true);
            }
        },
        ctaArtemFunnel() {
            this.tab = 'team';
            window.location.hash = 'team';
            this.$nextTick(() => { this.selectTeamChat('team_general'); this.teamInput = '@artem funnel'; });
        },
        ctaArtemHypotheses() {
            this.tab = 'team';
            window.location.hash = 'team';
            this.$nextTick(() => { this.selectTeamChat('artem'); this.teamInput = '@artem hypotheses'; });
        },
        ctaArtemExplainMetrics() {
            this.tab = 'team';
            window.location.hash = 'team';
            this.$nextTick(() => { this.selectTeamChat('artem'); this.teamInput = '@artem explain_metrics'; });
        },

        async loadBrief() {
            this.briefLoading = true;
            this.briefLoadFailed = false;
            this._briefRetries = 0;
            const maxRetries = 3;
            const attempt = async () => {
                try {
                    const r = await fetch('/api/brief');
                    if (r.ok) {
                        const data = await r.json();
                        this.briefData = data;
                        this.briefLoading = false;
                        this.initCharts();
                        if (this.briefData && this.briefData.knowledge_bank_enabled) this.loadKnowledge();
                        if (this.briefData) this.loadWeeklyFocus();
                        if (this.briefData && this.briefData.smart_tasks_enabled) this.loadSmartTasks();
                        return;
                    }
                    if (r.status === 404) { this.briefLoading = false; return; }
                } catch (_) {}
                this._briefRetries++;
                if (this._briefRetries < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 1500 * this._briefRetries));
                    return attempt();
                } else {
                    this.briefLoading = false;
                    this.briefLoadFailed = true;
                }
            };
            return attempt();
        },
        async loadSmartTasks() {
            try {
                const r = await fetch('/api/tasks?limit=15');
                if (r.ok) {
                    const d = await r.json();
                    this.smartTasksList = (d.tasks || []).map(t => ({ state: 'todo', ...t, _completing: false, _skipping: false }));
                }
            } catch (_) {}
        },
        async loadJournalHistory(limit = 8) {
            try {
                const url = '/api/journal/weeks?limit=' + encodeURIComponent(limit);
                const r = await fetch(url);
                if (!r.ok) return;
                const d = await r.json().catch(() => ({}));
                if (d && Array.isArray(d.weeks)) { this.journalHistory = d.weeks; }
            } catch (_) {}
        },
        async generateSmartTasks() {
            this.smartTasksError = '';
            this.smartTasksGenerateLoading = true;
            try {
                const r = await fetch('/api/tasks/generate', { method: 'POST', headers: { 'X-CSRF-Token': window.getCsrfToken() } });
                const d = await r.json().catch(() => ({}));
                if (r.ok) { await this.loadSmartTasks(); await this.reloadStage(); } else {
                    this.smartTasksError = (d.error || 'Не удалось сгенерировать шаги.') + (d.error_detail ? (': ' + d.error_detail) : '');
                }
            } catch (_) { this.smartTasksError = 'Ошибка сети при генерации шагов.'; }
            this.smartTasksGenerateLoading = false;
        },
        async taskComplete(taskId) {
            const t = this.smartTasksList.find(x => x.id === taskId);
            if (!t || t._completing || t.state === 'done') return;
            t._completing = true;
            try {
                const r = await fetch('/api/tasks/complete', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ task_id: taskId }) });
                if (r.ok) {
                    t.state = 'done';
                    if (this.weeklyTotalCount > 0 && this.weeklyDoneCount >= this.weeklyTotalCount) {
                        this.weeklyDoneToast = 'Все шаги на эту неделю выполнены. Отличная работа!';
                        setTimeout(() => { this.weeklyDoneToast = ''; }, 4000);
                    }
                }
            } catch (_) {}
            t._completing = false;
        },
        async taskSkip(taskId) {
            const t = this.smartTasksList.find(x => x.id === taskId);
            if (!t || t._skipping || t.state === 'skipped') return;
            t._skipping = true;
            try {
                const r = await fetch('/api/tasks/skip', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ task_id: taskId }) });
                if (r.ok) { t.state = 'skipped'; }
            } catch (_) {}
            t._skipping = false;
        },
        async loadWeeklyFocus() {
            try {
                const r = await fetch('/api/weekly-focus');
                if (r.ok) { const d = await r.json(); this.weeklyFocusGoals = d.goals || []; this.weeklyFocusWeekStart = d.week_start || ''; }
            } catch (_) {}
        },
        async openWeeklyFocusGenerate() {
            this.weeklyFocusGenerateLoading = true;
            this.weeklyFocusDraft = null;
            this.weeklyFocusMessage = '';
            try {
                const r = await fetch('/api/weekly-focus/generate', { method: 'POST', headers: { 'X-CSRF-Token': window.getCsrfToken() } });
                const d = await r.json().catch(() => ({}));
                if (r.ok && Array.isArray(d.goals) && d.goals.length > 0) {
                    this.weeklyFocusDraft = (d.goals || []).map(g => ({ ...g, _title: g.title || '', _description: g.description || '' }));
                    this.weeklyFocusWeekStart = d.week_start || this.weeklyFocusWeekStart;
                    this.weeklyFocusMessage = d.message || '';
                } else {
                    this.weeklyFocusDraft = null;
                    this.weeklyFocusMessage = (d.error || 'Не удалось сгенерировать фокус.') + (d.error_detail ? (': ' + d.error_detail) : '');
                }
                this.weeklyFocusModalOpen = true;
            } catch (_) {
                this.weeklyFocusDraft = null;
                this.weeklyFocusMessage = 'Ошибка сети при генерации фокуса.';
                this.weeklyFocusModalOpen = true;
            }
            this.weeklyFocusGenerateLoading = false;
        },
        closeWeeklyFocusModal() { this.weeklyFocusModalOpen = false; this.weeklyFocusDraft = null; },
        async saveWeeklyFocusDraft() {
            if (!this.weeklyFocusDraft || this.weeklyFocusDraft.length === 0) return;
            const goals = this.weeklyFocusDraft.map(g => ({
                title: (g._title || g.title || '').trim(), description: (g._description || g.description || '').trim(),
                metric_key: g.metric_key || null, target_value: g.target_value != null ? g.target_value : null,
                impact_score: g.impact_score ?? 5, is_primary: !!g.is_primary
            }));
            this.weeklyFocusSaveLoading = true;
            try {
                const r = await fetch('/api/weekly-focus/save', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ week_start: this.weeklyFocusWeekStart, goals }) });
                const d = await r.json();
                if (r.ok) { this.weeklyFocusGoals = d.goals || []; this.closeWeeklyFocusModal(); await this.reloadStage(); } else {
                    this.weeklyFocusMessage = (d.error || 'Ошибка сохранения') + (d.error_detail ? (': ' + d.error_detail) : '');
                }
            } catch (_) { this.weeklyFocusMessage = 'Ошибка сети'; }
            this.weeklyFocusSaveLoading = false;
        },
        async loadKnowledge() {
            try {
                const [scoreR, questionsR] = await Promise.all([ fetch('/api/knowledge/score'), fetch('/api/knowledge/questions?limit=2') ]);
                if (scoreR.ok) { const d = await scoreR.json(); this.knowledgeScore = d.score ?? 0; this.knowledgeNextSteps = d.next_steps ?? []; this.knowledgeBreakdown = d.breakdown ?? null; }
                if (questionsR.ok) { const d = await questionsR.json(); this.knowledgeQuestions = (d.questions ?? []).map(q => ({ ...q, _answer: '' })); }
            } catch (_) {}
        },
        async submitKnowledgeAnswer(questionId, answer) {
            this.knowledgeAnswerLoading = true;
            try {
                const prevScore = this.knowledgeScore ?? 0;
                const r = await fetch('/api/knowledge/answer', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ question_id: questionId, answer: answer.trim() }) });
                const d = await r.json();
                if (r.ok) {
                    const newScore = d.score ?? prevScore;
                    this.knowledgeScore = newScore;
                    this.knowledgeNextSteps = d.next_steps ?? this.knowledgeNextSteps;
                    this.knowledgeQuestions = this.knowledgeQuestions.filter(q => q.question_id !== questionId);
                    const diff = newScore - prevScore;
                    if (diff > 0) {
                        this.knowledgeToast = '+' + diff + ' баллов к банку знаний';
                        if (this.knowledgeBreakdown) { const cur = this.knowledgeBreakdown.extended_answered ?? 0; const total = this.knowledgeBreakdown.extended_total ?? 5; this.knowledgeBreakdown.extended_answered = Math.min(cur + 1, total); }
                        setTimeout(() => { this.knowledgeToast = ''; }, 3000);
                    }
                }
            } catch (_) {}
            this.knowledgeAnswerLoading = false;
        },

        async loadTeam() {
            this.teamError = '';
            try { const r = await fetch('/api/team'); if (r.ok) { const d = await r.json(); if (d.specialists) this.specialists = d.specialists; if (d.chat_meta) this.teamChatMeta = d.chat_meta; } } catch (_) {}
        },
        async loadTeamComments() {
            try { const r = await fetch('/api/chat?thread=team_general&limit=3&mark_read=0'); if (r.ok) { const d = await r.json(); this.teamComments = (d.messages || []).slice(-3); } } catch (_) {}
        },
        async loadFeed() {
            try { const r = await fetch('/api/dashboard/events?limit=20'); if (r.ok) { const d = await r.json(); this.feedEvents = (d.events || []).slice(0, 50); } } catch (_) {}
        },
        eventTypeLabel(type) {
            const labels = {
                'brief.completed': 'Маркетинговый бриф заполнен', 'weekly_focus.generated': 'Сформирован фокус недели', 'weekly_focus.edited': 'Обновлён фокус недели',
                'weekly_focus.applied': 'Применён фокус недели', 'task.generated': 'Сформирован список задач', 'task.saved': 'Обновлён список задач',
                'task.completed': 'Задача выполнена', 'task.skipped': 'Задача отложена', 'knowledge_base.updated': 'Обновлён банк знаний',
                'extended_brief.answered': 'Отвечен вопрос банка знаний', 'streak.updated': 'Обновлена серия продуктивных дней', 'badge.unlocked': 'Получен новый бейдж',
                'agent.recommended': 'Рекомендован агент', 'agent.subscription_started': 'Запущена подписка на агента', 'agent.subscription_stopped': 'Остановлена подписка на агента',
                'seo.channel_launched': 'Запущен SEO-канал', 'seo.phrases_added_from_recommended': 'Добавлены фразы в SEO-канал', 'seo.positions_viewed': 'Обновлён съём позиций по SEO',
                'audit.started': 'Запущен аудит сайта', 'audit.finished': 'Аудит сайта завершён', 'audit.failed': 'Ошибка аудита сайта', 'audit.timeout': 'Аудит сайта: превышено время ожидания',
            };
            return labels[type] || ('Событие: ' + String(type || '').replace(/[._]/g, ' '));
        },
        feedEventsGrouped() {
            if (!Array.isArray(this.feedEvents) || this.feedEvents.length === 0) return [];
            const byDay = {};
            this.feedEvents.forEach((ev) => { if (!ev || !ev.created_at) return; const dt = new Date(ev.created_at); if (Number.isNaN(dt.getTime())) return; const key = dt.toISOString().slice(0, 10); if (!byDay[key]) byDay[key] = []; byDay[key].push(ev); });
            const keys = Object.keys(byDay).sort((a, b) => (a < b ? 1 : -1));
            const today = new Date(); const todayKey = today.toISOString().slice(0, 10);
            const yesterday = new Date(); yesterday.setDate(today.getDate() - 1); const yesterdayKey = yesterday.toISOString().slice(0, 10);
            return keys.map((key) => { let label; if (key === todayKey) label = 'Сегодня'; else if (key === yesterdayKey) label = 'Вчера'; else { const [y, m, d] = key.split('-'); label = [d, m, y].join('.'); } return { dateKey: key, label, events: byDay[key] }; });
        },
        goToTeamGeneral() { this.tab = 'team'; window.location.hash = 'team'; this.$nextTick(() => this.selectTeamChat('team_general')); },

        async addAgentToTeam(agentId, targetChat = null) {
            if (agentId === 'fedor') this.addFedorLoading = true;
            try {
                const wasInTeam = this.specialists[agentId];
                const r = await fetch('/api/team', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ specialist: agentId, enabled: true }) });
                const d = await r.json();
                if (r.ok && d.specialists) {
                    this.specialists = d.specialists;
                    if (this.briefData && this.briefData.agent_recommendations) { this.briefData.agent_recommendations = this.briefData.agent_recommendations.filter(r => r.agent_id !== agentId); }
                    const chat = targetChat || (agentId === 'fedor' ? 'team_general' : agentId);
                    if (!wasInTeam && this.specialists[agentId]) { setTimeout(() => this.selectTeamChat(chat), 900); }
                } else if (!r.ok) { this.teamError = d.error || 'Ошибка'; }
            } catch (e) { this.teamError = 'Ошибка сети'; }
            if (agentId === 'fedor') this.addFedorLoading = false;
        },
        async addFedorToTeam() { return this.addAgentToTeam('fedor', 'team_general'); },
        async addDaryaToTeam() { return this.addAgentToTeam('darya', 'darya'); },

        async _pollChatJob(jobId, maxWaitMs = 65000) {
            const start = Date.now();
            let delay = 1000;
            while (Date.now() - start < maxWaitMs) {
                await new Promise(r => setTimeout(r, delay));
                delay = Math.min(Math.round(delay * 1.4), 4000);
                try {
                    const r = await fetch('/api/chat/job-status?job_id=' + encodeURIComponent(jobId));
                    if (r.ok) { const d = await r.json(); if (d.status === 'done' || d.status === 'error') return d; }
                    else if (r.status === 404) { return { status: 'error', error: 'Задание устарело. Попробуйте ещё раз.' }; }
                    else if (r.status === 503) { return { status: 'error', error: 'Сервис временно недоступен. Попробуйте позже.' }; }
                } catch (_) {}
            }
            return { status: 'error', error: 'Ответ занял слишком много времени. Попробуйте ещё раз.' };
        },

        async toggleFedor() {
            const wasInTeam = this.specialists.fedor;
            const newVal = !this.specialists.fedor;
            try {
                const r = await fetch('/api/team', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ specialist: 'fedor', enabled: newVal }) });
                const d = await r.json();
                if (r.ok && d.specialists) { this.specialists = d.specialists; if (!wasInTeam && this.specialists.fedor) { setTimeout(() => this.selectTeamChat('team_general'), 900); } } else { this.specialists.fedor = wasInTeam; if (!r.ok) this.teamError = d.error || 'Ошибка'; }
            } catch (e) { this.specialists.fedor = wasInTeam; this.teamError = 'Ошибка сети'; }
            if (!this.specialists.fedor && this.activeTeamChat === 'fedor') { this.activeTeamChat = 'artem'; this.selectTeamChat('artem'); }
        },

        async toggleDarya() {
            const wasInTeam = this.specialists.darya;
            const newVal = !this.specialists.darya;
            try {
                const r = await fetch('/api/team', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ specialist: 'darya', enabled: newVal }) });
                const d = await r.json();
                if (r.ok && d.specialists) { this.specialists = d.specialists; if (!wasInTeam && this.specialists.darya) { setTimeout(() => this.selectTeamChat('darya'), 900); } } else { this.specialists.darya = wasInTeam; if (!r.ok) this.teamError = d.error || 'Ошибка'; }
            } catch (e) { this.specialists.darya = wasInTeam; this.teamError = 'Ошибка сети'; }
            if (!this.specialists.darya && this.activeTeamChat === 'darya') { this.activeTeamChat = 'artem'; this.selectTeamChat('artem'); }
        },

        _historyMessages(arr) {
            return (arr || []).map((m, i) => ({ ...m, _key: 'h' + i + (m.created_at || ''), _justArrived: false }));
        },

        teamMessageMatchesSearch(m) {
            const q = (this.teamChatSearchQuery || '').trim().toLowerCase();
            if (!q) return true;
            return (String(m.content || '')).toLowerCase().includes(q);
        },

        teamConnectorAgentLabel(agentId) {
            const id = (agentId || 'artem').toString();
            const map = { artem: 'Артём', fedor: 'Фёдор', darya: 'Дарья', anton: 'Антон' };
            return map[id] || id;
        },

        async clearTeamChat() {
            if (!this.activeTeamChat) return;
            if (!confirm('Удалить все сообщения в этом чате? Это действие нельзя отменить.')) return;
            this.teamError = '';
            try {
                const res = await fetch('/api/chat?thread=' + encodeURIComponent(this.activeTeamChat), {
                    method: 'DELETE',
                    headers: { 'X-CSRF-Token': window.getCsrfToken() },
                });
                const data = await res.json().catch(() => ({}));
                if (!res.ok) {
                    this.teamError = data.error || 'Не удалось очистить чат';
                    return;
                }
                this.teamMessages = [];
                this.teamChatMoreOpen = false;
                this.teamChatSearchQuery = '';
                window.dispatchEvent(new CustomEvent('refresh-unread'));
            } catch (_) {
                this.teamError = 'Ошибка сети';
            }
        },

        async selectTeamChat(id) {
            if (this.onboardingTypingTimer) { clearTimeout(this.onboardingTypingTimer); this.onboardingTypingTimer = null; }
            this.onboardingPending = [];
            this.teamChatSearchOpen = false;
            this.teamChatSearchQuery = '';
            this.teamChatMoreOpen = false;
            this.teamLoading = true;
            this.activeTeamChat = id;
            if (this.teamChatMeta[id]) { this.teamChatMeta = { ...this.teamChatMeta, [id]: { ...this.teamChatMeta[id], unread_count: 0 } }; }
            window.dispatchEvent(new CustomEvent('refresh-unread'));
            this.teamMessages = [];
            let allMessages = [];
            try { const r = await fetch('/api/chat?thread=' + encodeURIComponent(id)); if (r.ok) { const d = await r.json(); allMessages = d.messages || []; } } catch (_) {}
            this.teamLoading = false;
            if (this.onboardingMode && id === 'team_general' && allMessages.length > 0) {
                this.onboardingMode = false;
                try { const url = new URL(window.location.href); url.searchParams.delete('onboarding'); window.history.replaceState({}, '', url.toString()); } catch (_) {}
                this.teamMessages = [];
                this.onboardingPending = [...allMessages];
                this._playNextOnboardingMessage();
                return;
            }
            this.teamMessages = this._historyMessages(allMessages);
            this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });
        },

        _playNextOnboardingMessage() {
            if (this.onboardingPending.length === 0) { this.teamLoading = false; return; }
            const msg = this.onboardingPending.shift();
            const textLen = (msg.content || '').length;
            const typingMs = Math.min(2800, Math.max(1200, textLen * 18));
            this.teamLoading = true;
            this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });
            this.onboardingTypingTimer = setTimeout(() => {
                this.teamLoading = false;
                this.teamMessages.push(msg);
                this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });
                if (this.onboardingPending.length > 0) { this.onboardingTypingTimer = setTimeout(() => { this._playNextOnboardingMessage(); }, 600); }
            }, typingMs);
        },

        async markFedorTaskDone(taskId, messageIdx) {
            if (!this.activeTeamChat || this.teamTaskDoneLoading) return;
            this.teamTaskDoneLoading = true;
            try {
                const res = await fetch('/api/chat', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken(), 'X-Chat-Async': '1' }, body: JSON.stringify({ message: '@fedor done ' + taskId, thread: this.activeTeamChat }) });
                const rawData = await res.json();
                if (!res.ok) { this.teamError = rawData.error || 'Ошибка при отметке задачи'; return; }
                let data = rawData;
                if (rawData.status === 'queued' && rawData.job_id) { const result = await this._pollChatJob(rawData.job_id); if (result.status !== 'done') { this.teamError = result.error || 'Не удалось получить ответ'; return; } data = result; }
                const hist = await fetch('/api/chat?thread=' + encodeURIComponent(this.activeTeamChat));
                if (hist.ok) {
                    const h = await hist.json(); this.teamMessages = this._historyMessages(h.messages);
                    const withTasks = this.teamMessages.filter(m => m.tasks && Array.isArray(m.tasks));
                    for (let i = withTasks.length - 1; i >= 0; i--) { const t = withTasks[i].tasks.find(x => (x.id || 0) === taskId); if (t) { t.status = 'done'; break; } }
                } else {
                    const now = new Date().toISOString();
                    this.teamMessages.push({ role: 'user', content: '@fedor done ' + taskId, created_at: now });
                    this.teamMessages.push({ role: 'assistant', content: data.answer, created_at: now, _justArrived: true });
                    const msg = this.teamMessages[messageIdx]; if (msg && msg.tasks) { const t = msg.tasks.find(x => (x.id || 0) === taskId); if (t) t.status = 'done'; }
                }
                this.$nextTick(() => { const b = this.$refs.teamBox; if (b) b.scrollTop = b.scrollHeight; });
            } finally { this.teamTaskDoneLoading = false; }
        },

        /**
         * Общая обработка ответа /api/chat для чата команды: многошаговая летучка (коннекторы + «печатает»)
         * или одна реплика / перезагрузка истории. И текст, и голос должны вызывать одно и то же.
         */
        async processTeamChatResult(data, toSend) {
            this.teamError = '';
            if (Array.isArray(data.steps) && data.steps.length > 0) {
                if (this.teamTypingTimer) { clearTimeout(this.teamTypingTimer); this.teamTypingTimer = null; }
                this.teamTypingPhase = 0;

                const connectorText = {
                    fedor: 'Артём → Фёдор: дай краткий статус по SEO',
                    anton: 'Артём → Антон: что с рекламным бюджетом?',
                    darya: 'Артём → Дарья: как обстоят дела с контентом?',
                };

                const agentStatusSteps = {
                    artem: [
                        'Артём анализирует данные по проекту...',
                        'Артём формирует обзор каналов...',
                    ],
                    fedor: [
                        'Фёдор запрашивает данные из Яндекс.Вебмастер...',
                        'Фёдор анализирует позиции по запросам...',
                        'Фёдор формирует рекомендации по SEO...',
                    ],
                    anton: [
                        'Антон запрашивает данные из Яндекс.Директ...',
                        'Антон получает статистику звонков...',
                        'Антон анализирует рекламный бюджет...',
                    ],
                    darya: [
                        'Дарья проверяет контент-план...',
                        'Дарья анализирует охваты публикаций...',
                    ],
                };

                for (let i = 0; i < data.steps.length; i++) {
                    const step = data.steps[i];
                    const agentId = step.agent_id || 'artem';

                    if (agentId !== 'artem' && connectorText[agentId] && !step.no_connector) {
                        this.teamMessages.push({
                            role: 'system_connector',
                            content: connectorText[agentId],
                            from_agent: 'artem',
                            to_agent: agentId,
                            created_at: new Date().toISOString(),
                            _justArrived: true,
                        });
                        this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });
                        await new Promise(r => setTimeout(r, 600));
                    }

                    this.teamTypingAgent = agentId;
                    this.teamLoading = true;
                    this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });

                    const statuses = agentStatusSteps[agentId] || [];
                    const typingDelay = Math.min(3800, Math.max(1600, (step.content || '').length * 18));
                    const stepTime = 950;
                    let elapsed = 0, si = 0;
                    while (elapsed < typingDelay) {
                        this.teamTypingStatus = statuses[si % statuses.length] || '';
                        const wait = Math.min(stepTime, typingDelay - elapsed);
                        await new Promise(r => setTimeout(r, wait));
                        elapsed += stepTime;
                        si++;
                    }

                    this.teamTypingStatus = '';
                    this.teamLoading = false;
                    this.teamTypingAgent = null;
                    this.teamMessages.push({ role: 'assistant', content: step.content || '', agent_id: agentId, created_at: new Date().toISOString(), _justArrived: true });
                    this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });

                    if (i < data.steps.length - 1) {
                        await new Promise(r => setTimeout(r, 350));
                    }
                }
            } else {
                const hist = await fetch('/api/chat?thread=' + encodeURIComponent(this.activeTeamChat));
                if (hist.ok) { const h = await hist.json(); this.teamMessages = this._historyMessages(h.messages); } else {
                    const lastMsg = { role: 'assistant', content: data.answer, created_at: new Date().toISOString(), _justArrived: true };
                    if (Array.isArray(data.tasks)) lastMsg.tasks = data.tasks;
                    this.teamMessages.push(lastMsg);
                }
                if (Array.isArray(data.tasks)) { const lastAssistant = this.teamMessages.filter(m => m.role === 'assistant').pop(); if (lastAssistant) lastAssistant.tasks = data.tasks; }
                if (/@fedor\s+done\s+(\d+)/i.test(toSend)) {
                    const num = parseInt(toSend.replace(/@fedor\s+done\s+(\d+)/i, '$1'), 10);
                    const withTasks = this.teamMessages.filter(m => m.tasks && Array.isArray(m.tasks));
                    for (let i = withTasks.length - 1; i >= 0; i--) { const t = withTasks[i].tasks.find(x => (x.id || 0) === num || (x.id === undefined && i + 1 === num)); if (t) { t.status = 'done'; break; } }
                }
                this.$nextTick(() => { const box = this.$refs.teamBox; if (box) box.scrollTop = box.scrollHeight; });
            }
        },

        async sendTeamMessage() {
            if (!this.teamInput.trim() || !this.activeTeamChat) return;
            this.teamError = '';
            const toSend = this.teamInput;
            const now = new Date().toISOString();
            this.teamMessages.push({ role: 'user', content: toSend, created_at: now, _justArrived: true });
            this.teamInput = '';
            this.teamLoading = true;
            this.teamTypingPhase = 0;
            this.teamTypingTimer = window.setTimeout(() => { if (this.activeTeamChat === 'team_general') this.teamTypingPhase = 1; }, 1500);
            this.$nextTick(() => { const b = this.$refs.teamBox; if (b) b.scrollTop = b.scrollHeight; });
            try {
                const res = await fetch('/api/chat', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken(), 'X-Chat-Async': '1' }, body: JSON.stringify({ message: toSend, thread: this.activeTeamChat }) });
                const rawData = await res.json();
                if (!res.ok) {
                    this.teamError = rawData.error || 'Ошибка'; if (rawData.error_detail) this.teamError += ': ' + rawData.error_detail;
                    if (res.status === 429 && this.teamMessages.length && this.teamMessages[this.teamMessages.length - 1].role === 'user' && this.teamMessages[this.teamMessages.length - 1].content === toSend) { this.teamMessages.pop(); this.teamInput = toSend; }
                    return;
                }
                let data = rawData;
                if (rawData.status === 'queued' && rawData.job_id) { const result = await this._pollChatJob(rawData.job_id); if (result.status !== 'done') { this.teamError = result.error || 'Ошибка при получении ответа'; return; } data = result; }
                await this.processTeamChatResult(data, toSend);
            } catch (e) { this.teamError = 'Сетевой запрос не удался'; } finally {
                if (this.teamTypingTimer) { clearTimeout(this.teamTypingTimer); this.teamTypingTimer = null; }
                this.teamLoading = false; this.teamTypingPhase = 0;
            }
        },

        async startVoiceRecord(context) {
            if (this.voiceRecorder) return;
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                const mime = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
                this.voiceRecorder = new MediaRecorder(stream);
                this.voiceChunks = [];
                this.voiceRecorder.ondataavailable = (e) => { if (e.data.size) this.voiceChunks.push(e.data); };
                this.voiceRecorder.onstop = async () => {
                    stream.getTracks().forEach(t => t.stop());
                    const blob = new Blob(this.voiceChunks, { type: mime.split(';')[0] });
                    await this.sendVoiceMessage(blob, context);
                    this.voiceRecorder = null; this.voiceChunks = [];
                    if (context === 'team') this.teamVoiceRecording = false;
                };
                this.voiceRecorder.start();
                if (context === 'team') this.teamVoiceRecording = true;
            } catch (e) { if (context === 'team') this.teamError = 'Нет доступа к микрофону'; }
        },
        stopVoiceRecord() { if (this.voiceRecorder && this.voiceRecorder.state !== 'inactive') this.voiceRecorder.stop(); },
        async sendVoiceMessage(blob, context) {
            const isTeam = context === 'team';
            if (isTeam && !this.activeTeamChat) return;
            if (isTeam) this.teamError = '';
            if (isTeam) this.teamLoading = true;
            try {
                const fd = new FormData();
                fd.append('audio', blob, 'voice.webm');
                if (isTeam) fd.append('thread', this.activeTeamChat);
                const res = await fetch('/api/chat', { method: 'POST', headers: { 'X-CSRF-Token': window.getCsrfToken(), 'X-Chat-Async': '1' }, body: fd });
                const rawData = await res.json();
                if (!res.ok) { let err = rawData.error || 'Ошибка'; if (rawData.error_detail) err += ': ' + rawData.error_detail; if (isTeam) this.teamError = err; return; }
                const now = new Date().toISOString();
                const transcribed = rawData.transcribed_text || null;
                let data = rawData;
                if (rawData.status === 'queued' && rawData.job_id) { const result = await this._pollChatJob(rawData.job_id); if (result.status !== 'done') { const err = result.error || 'Ошибка при получении ответа'; if (isTeam) this.teamError = err; return; } data = result; }
                if (transcribed) {
                    if (isTeam) {
                        this.teamMessages.push({ role: 'user', content: transcribed, created_at: now, _justArrived: true });
                        this.$nextTick(() => { const b = this.$refs.teamBox; if (b) b.scrollTop = b.scrollHeight; });
                        await this.processTeamChatResult(data, transcribed);
                    }
                } else {
                    if (isTeam) {
                        const hist = await fetch('/api/chat?thread=' + encodeURIComponent(this.activeTeamChat));
                        if (hist.ok) { const h = await hist.json(); this.teamMessages = this._historyMessages(h.messages); } else { this.teamMessages.push({ role: 'user', content: '(голосовое сообщение)', created_at: now, _justArrived: true }); this.teamMessages.push({ role: 'assistant', content: data.answer, created_at: now, _justArrived: true }); }
                        this.$nextTick(() => { const b = this.$refs.teamBox; if (b) b.scrollTop = b.scrollHeight; });
                    }
                }
            } catch (e) { if (isTeam) this.teamError = 'Сетевой запрос не удался'; } finally {
                if (isTeam) {
                    if (this.teamTypingTimer) { clearTimeout(this.teamTypingTimer); this.teamTypingTimer = null; }
                    this.teamLoading = false;
                    this.teamTypingPhase = 0;
                    this.teamTypingAgent = null;
                    this.teamTypingStatus = '';
                }
            }
        }
    }));
}
